import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="text-center py-5 px-6 text-sm border-t border-black/10">
      Copyright &copy; {new Date().getFullYear()}{" "}
      <Link className="text-[#6c5ffc]" to="https://app.dbi360.com/">
        DBI360. 
      </Link>{" "}
      All rights reserved.
    </div>
  );
};

export default Footer;